export const NotificationType = {
  FRIEND_REQUEST: 'friend_request',
  CHALLENGE: 'challenge',
  MESSAGE: 'message',
  SYSTEM: 'system',
};

export const NotificationPriority = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
};

/** @typedef {Object} NotificationEvent
 * @property {string} type
 * @property {string} title
 * @property {string} body
 * @property {'low'|'medium'|'high'} [priority]
 * @property {string} [dedupeKey]
 * @property {boolean} [group]
 * @property {Record<string, unknown>} [meta]
 */
